<div class="wrapper">
  <div class="emr-page-container">
    <div class="emr-page-title">Select a Container to Open</div>

    @if (!loaded()) {
    <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
    } @else {
      <app-knightmeds-diagram [containerLabels]="containerLabels()"
        [containerWarnings]="containerWarnings()"
        (onContainerClicked)="onContainerClicked($event)"></app-knightmeds-diagram>
    }
  </div>
</div>